module.exports = __webpack_public_path__ + "img/solution3-2.252a366e.png";